import React from 'react';
import Modal from 'containers/Modal/Modal';
import { clearConfirm } from 'actions/confirm/';
import { Confirm as Form } from 'components/Confirm/';
import { useSelector, useDispatch } from 'react-redux';

function Confirm() {
  const dispatch = useDispatch();
  const confirm = useSelector((s) => s.confirm);
  const {
    type = '',
    title = '',
    options = {},
    onCancel = null,
    checkCaption = '',
  } = confirm;
  const { deleting } = options;
  const caption = deleting ? 'Confirm record deletion' : title;

  function onCloseModal() {
    dispatch(clearConfirm());
    if (onCancel) {
      onCancel();
    }
  }

  return (
    <Modal
      isConfirmModal
      modalWidth={40}
      caption={caption}
      isOpen={type !== ''}
      onClose={onCloseModal}
    >
      <Form
        confirm={confirm}
        onClose={onCloseModal}
        checkCaption={checkCaption}
      />
    </Modal>
  );
}

export default Confirm;
